import { Comics } from "./comics";

export const structureFilterConst = {
    "comics" : Comics
}